import { useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import UseBreakpoints from "../../hooks/ui/UseBreakpoints";
import GroupSelectOption from "./GroupSelectOption";
import NameCard from "./NameCard";
import { getMemberbyId } from "../../../context/members/membercontext";
const MemberListTemplate = ({ groups }) => {
  // const cardVariants = {
  //   offscreen: {
  //     y: 40,
  //     opacity: 0,
  //   },
  //   onscreen: {
  //     y: 0,
  //     opacity: 1,
  //     transition: {
  //       type: "spring",
  //       bounce: 0.6,
  //       duration: 1,
  //       damping: 20,
  //     },
  //   },
  // };
  const [selectedmembers, setSelectedMembers] = useState(groups[0].members);
  const [selected, setSelected] = useState(1);
  const breakpoints = UseBreakpoints();
  return (
    <ContentsDiv breakpoints={breakpoints}>
      <GroupSelect breakpoints={breakpoints}>
        {groups?.map(({ category, members }, idx) => (
          <GroupSelectOption
            title={category}
            contents={members}
            setContents={setSelectedMembers}
            setSelected={setSelected}
            key={idx + 1}
            value={idx + 1}
            selected={selected}
          />
        ))}
      </GroupSelect>
      <NameCardsDiv breakpoints={breakpoints}>
        {/* <motion.ul
            className="container"
            variants={container}
            initial="hidden"
            animate="visible"
          > */}
        {selectedmembers?.map((x, idx) => (
          <motion.div
            key={idx}
            initial="offscreen"
            whileInView="onscreen"
            viewport={{ once: true, amount: 0.8 }}
            // variants={cardVariants}
          >
            <NameCard key={x} member={getMemberbyId(x)} consult />
          </motion.div>
        ))}
        {/* </motion.ul> */}
      </NameCardsDiv>
    </ContentsDiv>
  );
};
export default MemberListTemplate;
const ContentsDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const GroupSelect = styled.div`
  position: sticky;
  top: calc(${({ theme }) => theme.layout.header} + 0.75rem);
  z-index: 3;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.25rem;
  background-color: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(8px);
  border: 1px solid ${({ theme }) => theme.colors.line};
  box-shadow: ${({ theme }) => theme.shadow.sm};
  padding: 0.35rem;
  border-radius: 1.75rem;
  margin: 3.5rem 0 3rem 0;
  & > * {
    cursor: pointer;
  }
  @media (max-width: 575px) {
    border-radius: 1.25rem;
  }
`;

const NameCardsDiv = styled.div`
  width: 100%;
  display: grid;
  justify-content: center;
  grid-template-columns: ${({ breakpoints }) =>
    breakpoints?.lg ? "repeat(2, minmax(0, 30rem))" : "minmax(0, 30rem)"};
  gap: 1.5rem;
  min-height: 60vh;
  align-content: start;
  list-style: none;
`;
